// extracted by mini-css-extract-plugin
export var logo = "TrustedSection-module--logo--f6309";
export var partner = "TrustedSection-module--partner--80fba";
export var partners = "TrustedSection-module--partners--bc89b";
export var root = "TrustedSection-module--root--a05d0";
export var title = "TrustedSection-module--title--3fdd0";